import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function SiteFooter() {
  const hotPosts = articles.slice(0, 3);
  const tags = ['反转盘点', '录音流出', '聊天记录', '当事人回应', '打脸现场'];
  return (
    <footer className="w-full bg-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-6 pt-12 pb-8">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="mb-3 flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg font-bold text-background-50">瓜</span>
              <div className="leading-none">
                <p className="font-label text-base font-extrabold text-foreground-950">每日大瓜</p>
                <p className="text-[11px] text-foreground-500">全网吃瓜时间线</p>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-foreground-600">
              每天为你整理全网吃瓜时间线，瓜中瓜连环反转全程追踪。当事人回应、录音流出、聊天记录截图，关键证据一应俱全。
            </p>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-bold text-foreground-950">栏目导航</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="inline-flex items-center gap-1.5 transition hover:text-primary-700">
                    <i className={`${c.icon} text-primary-600`} aria-hidden="true" />
                    {c.name}
                    <span className="text-xs text-foreground-400">· {c.desc.split('，')[0]}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-bold text-foreground-950">热议时间线</h4>
            <ul className="space-y-2.5 text-sm">
              {hotPosts.map((p) => (
                <li key={p.id} className="flex items-start gap-2">
                  <i className="ri-flashlight-fill mt-0.5 text-accent-600" aria-hidden="true" />
                  <Link to={`/post/${p.id}`} className="line-clamp-2 leading-snug text-foreground-600 transition hover:text-primary-700">
                    {p.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-bold text-foreground-950">常见瓜型</h4>
            <div className="flex flex-wrap gap-2">
              {tags.map((t) => (
                <Link
                  key={t}
                  to="/"
                  className="inline-flex items-center whitespace-nowrap rounded-full bg-background-50 border border-background-200 px-3 py-1 text-xs text-foreground-600 transition hover:border-primary-300 hover:text-primary-700"
                >
                  <i className="ri-price-tag-3-line mr-1 text-primary-500" aria-hidden="true" />
                  {t}
                </Link>
              ))}
            </div>
            <p className="mt-4 text-sm text-foreground-600">
              建议或爆料，欢迎来信：
              <a href="mailto:hello@example.com" className="ml-1 text-primary-600 hover:underline">
                hello@example.com
              </a>
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-5 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 每日大瓜 · 全网吃瓜时间线。内容为娱乐资讯整理，仅供观点展示。</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition hover:text-primary-700">关于我们</Link>
            <Link to="/about" className="transition hover:text-primary-700">联系方式</Link>
            <span className="inline-flex items-center gap-1">
              <i className="ri-sparkling-2-line text-accent-600" aria-hidden="true" /> 每天一颗瓜，追剧不迷路
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}